import { formatMagnitude } from '@dawn/core/utils';
import { IdentityAccessBody } from '@dawn/ui';

import type { WidgetConfig } from '@/config/dashboard.types';

import { WidgetShell } from '../WidgetShell';

/**
 * Inline mirror of the dashboard API's `HumanIdentitiesResponse`. Kept local
 * per design §5 #11 — no shared contract package for V2.
 */
interface DepartmentBreakdownItem {
  id: string;
  label: string;
  count: number;
  isHighlighted?: boolean;
}
interface HumanIdentitiesResponseData {
  total: number;
  change: number;
  changeDirection: 'positive' | 'negative' | 'neutral';
  activeCount: number;
  activePercent: number;
  nonActiveCount: number;
  nonActivePercent: number;
  departmentBreakdown: DepartmentBreakdownItem[];
}

function narrowHumanIdentitiesData(input: unknown): HumanIdentitiesResponseData | null {
  if (input === null || typeof input !== 'object') return null;
  const candidate = input as Record<string, unknown>;
  if (!Array.isArray(candidate.departmentBreakdown)) return null;
  return candidate as unknown as HumanIdentitiesResponseData;
}

export function HumanIdentitiesWidget({ config }: { config: WidgetConfig }) {
  return (
    <WidgetShell
      config={config}
      renderData={(envelopeData) => {
        const data = narrowHumanIdentitiesData(envelopeData);
        if (!data) return null;
        return (
          <IdentityAccessBody
            total={data.total}
            change={data.change}
            changeDirection={data.changeDirection}
            activeCount={data.activeCount}
            activePercent={data.activePercent}
            nonActiveCount={data.nonActiveCount}
            nonActivePercent={data.nonActivePercent}
            breakdown={data.departmentBreakdown}
            caption="Human Identities"
            popoverTitle="Total Human Identities"
            popoverCategory="Department"
            donutCenterLabel="Active"
            activeLegendLabel="Active"
            nonActiveLegendLabel="Non-active"
            formatNumber={formatMagnitude}
          />
        );
      }}
    />
  );
}
